import { render, staticRenderFns } from "./superSearchItem.vue?vue&type=template&id=4e9af435&"
import script from "./superSearchItem.vue?vue&type=script&lang=js&"
export * from "./superSearchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/superSearchItem.vue"
export default component.exports